(function () {
  if (customElements.get('delivery-countdown')) return;

  const TIME_ZONE = 'Europe/Copenhagen';
  const WEEKDAYS = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
  const DAY_MS = 24 * 60 * 60 * 1000;

  const partsFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: TIME_ZONE,
    hourCycle: 'h23',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  });

  // Wall-clock date and time in Copenhagen for an instant
  function zonedParts(date) {
    const parts = {};
    partsFormatter.formatToParts(date).forEach(({ type, value }) => {
      parts[type] = Number(value);
    });
    return parts;
  }

  // The instant at which Copenhagen's clock shows the given date and time
  function zonedTimeToDate(year, month, day, hour) {
    const wallClock = Date.UTC(year, month - 1, day, hour);
    const p = zonedParts(new Date(wallClock));
    const offset = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - wallClock;
    return new Date(wallClock - offset);
  }

  function dateKey(year, month, day) {
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  }

  class DeliveryCountdown extends HTMLElement {
    connectedCallback() {
      this.cutoffHour = Number(this.dataset.cutoffHour) || 15;
      this.closedDates = new Set(
        (this.dataset.closedDates || '')
          .split(/[\s,]+/)
          .map((value) => value.trim())
          .filter(Boolean)
      );
      this.timeElement = this.querySelector('[data-countdown-time]');
      this.dayElement = this.querySelector('[data-countdown-day]');

      this.update();
      this.hidden = false;
      this.interval = setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    isShippingDay(year, month, day) {
      const weekday = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
      return weekday !== 0 && weekday !== 6 && !this.closedDates.has(dateKey(year, month, day));
    }

    // Next cut-off from now, and how many calendar days away it is
    nextCutoff(now) {
      const today = zonedParts(now);
      const todayUtc = Date.UTC(today.year, today.month - 1, today.day);

      for (let offset = 0; offset < 60; offset++) {
        const day = new Date(todayUtc + offset * DAY_MS);
        const year = day.getUTCFullYear();
        const month = day.getUTCMonth() + 1;
        const date = day.getUTCDate();
        if (!this.isShippingDay(year, month, date)) continue;

        const cutoff = zonedTimeToDate(year, month, date, this.cutoffHour);
        if (cutoff > now) return { cutoff, offset, weekday: day.getUTCDay() };
      }
      return null;
    }

    update() {
      const now = new Date();
      const next = this.nextCutoff(now);
      if (!next) {
        this.hidden = true;
        return;
      }

      const remaining = Math.floor((next.cutoff - now) / 1000);
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      this.timeElement.textContent = `${hours}t ${minutes}m ${seconds}s`;

      if (next.offset === 0) {
        this.dayElement.textContent = 'i dag';
      } else if (next.offset === 1) {
        this.dayElement.textContent = 'i morgen';
      } else {
        this.dayElement.textContent = `på ${WEEKDAYS[next.weekday]}`;
      }
    }
  }

  customElements.define('delivery-countdown', DeliveryCountdown);
})();
